export var isClientSide = typeof window === 'object';
export var isServerSide = !isClientSide;
export default { isClientSide: isClientSide, isServerSide: isServerSide };
//# sourceMappingURL=whereami.js.map